import React from 'react';
import {connect} from 'react-redux';
import RightMenuDetailsEksport from './RightMenuDetailsEksport';
import RightMenuDetailsRoutes from './RightMenuDetailsRoutes'
import RightMenuDetailsHelp from "./RightMenuDetailsHelp";

class RightMenuDetails extends React.Component {
    render() {
        return (
            <div className={'right-menu-details ' + (this.props.isExpandedRightMenu.expanded ? ' show' : '')}>
                {this.props.activeButtonName === 'eksport' && <RightMenuDetailsEksport/>}
                {this.props.activeButtonName === 'pomoc' && <RightMenuDetailsHelp style={{display: ''}}/>}
                {this.props.activeButtonName === 'scenariusze' && <RightMenuDetailsRoutes setResetSimulator={this.props.setResetSimulator}/>}
            </div>
        )
    }
}

export default connect(
    state => ({
        activeButtonName: state.activeButton.name,
        isExpandedRightMenu: state.expandRightMenu,
    }),
    {}
)(RightMenuDetails)



// WEBPACK FOOTER //
// ./src/RightMenu/RightMenuDetails.js